import { MessageCircle } from "lucide-react";
import { config } from "@/config";

export default function WhatsAppButton() {
  return (
    <a
      href={config.whatsapp.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Contactar por WhatsApp"
    >
      {/* Pulse animation */}
      <span className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-30" />
      
      {/* Button */}
      <div className="relative bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center">
        <MessageCircle size={24} className="fill-white" />
      </div>

      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#0A1628] text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg pointer-events-none">
        Chatea con nosotros
        <span className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 border-4 border-transparent border-l-[#0A1628]" />
      </span>
    </a>
  );
}
